import { useEffect } from "react";
import Contant from "./Contant";
import Footer from "./Footer";
import "./Home.css";
import { Helmet } from "react-helmet";

function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Ootygo</title>
        <meta
          name="description"
          content="Explore the beauty of Ooty with OotyGo's personalized tour packages. Experience hassle-free bookings, luxury accommodations, and guided tours. Discover Ooty like never before!"
        />
        <meta
          name="keywords"
          content="oty, ooty Hotels, ooty Hotel Booking, Best Hotels in Ooty, Affordable Accommodations, Luxury Stays, Ooty Resorts, Online Reservations, Mountain View Rooms, Family-Friendly Hotels, Business Travelers, Weekend Getaways, Honeymoon Suites, Central Location, Lake View Rooms, Group Bookings, Pet-Friendly Hotels, Ooty Accommodations, Book Direct, Last-Minute Deals, Boutique Hotels"
        />
      </Helmet>

      <Contant />

      <Footer />
    </>
  );
}
export default Home;
